import { render, staticRenderFns } from "./DeliveryPrice.vue?vue&type=template&id=e3dac154&scoped=true"
import script from "./DeliveryPrice.vue?vue&type=script&lang=js"
export * from "./DeliveryPrice.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPrice.vue?vue&type=style&index=0&id=e3dac154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dac154",
  null
  
)

export default component.exports